// This is example of menu item without group for horizontal layout. There will be no children.

// assets
import ChromeOutlined from '@ant-design/icons/ChromeOutlined';

// icons
const icons = { ChromeOutlined };

// ==============================|| MENU ITEMS - DASHBOARD ||============================== //

const dashboard = {
  id: 'dashboard',
  title: 'Dashboard',
  type: 'group',
  url: '/',
  icon: icons.ChromeOutlined
};

export default dashboard;
